<section id="top" class="section">
    <div class="hero inverted">
        <div class="hero-video video">
            <div class="hero-video__wrapper">
                <div class="hero-video__overlay"></div>
                <video class="hero-video__video" #video appAutoplayInView playsinline muted
                    preload="none">
                    <source src="assets/videos/marktbox-reel-00.mp4" type="video/mp4" />
                </video>
            </div>
        </div>
        <div class="hero-content">
            <div class="content content--wide">
                <div class="text__wrapper">
                    <div class="text">
                        <p class="caption" i18n="@@addonsCaption">Zubehör</p>
                        <h1 class="title display " i18n="@@addonsMainTitle">
                            Der "Hut mit Ohren"
                        </h1>
                        <div class="line"></div>
                        <p class="subtitle" i18n="@@addonsMainSubtitle">
                            Rüsten Sie Ihre <span class="tm">marktbox</span> für jedes Wetter.
                            Mit unserem neuen Dach und den passenden Seitenwänden steht Ihr Automat
                            auch im Außenbereich sicher und geschützt.
                        </p>
                    </div>
                    <div class="actions">
                        <a class="btn btn-primary" [routerLink]="links.shop" i18n="@@addonsLink">Zum Zubehör</a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>

<div class="addons-page">
    <div class="addons-container" #scrollSection>
        <div class="sticky-col">
            <div class="canvas-wrapper">
                <canvas #canvas></canvas>
            </div>
        </div>
        <div class="scroll-col">
            <div class="content-spacer"></div> <!-- Spacer to start content lower if needed -->

            <section class="addon-detail">
                <div class="text-content">
                    <div class="caption" i18n="@@addonsProtectedCaption">Rundum Geschützt</div>
                    <h2 class="display" i18n="@@addonsProtectedTitle">Wetterfestes Dach</h2>
                    <div class="line"></div>
                    <p class="copy" i18n="@@addonsProtectedText">
                        Der massive Dachaufbau schützt Ihre <span class="tm">marktbox</span> zuverlässig vor Regen,
                        Schnee und direkter
                        Sonneneinstrahlung.
                        So bleibt der Bedienbereich trocken und Ihre Kunden kaufen entspannter ein.
                    </p>
                </div>
            </section>

            <section class="addon-detail">
                <div class="text-content">
                    <div class="caption" i18n="@@addonsDesignCaption">Design & Funktion</div>
                    <h2 class="display" i18n="@@addonsDesignTitle">Die "Ohren"</h2>
                    <div class="line"></div>
                    <p class="copy" i18n="@@addonsDesignText">
                        Die seitlichen Elemente dienen als effektiver Windfang und Sichtschutz.
                        Sie schaffen einen geschützten Raum für Ihre Kunden und fokussieren die Aufmerksamkeit auf das
                        Angebot.
                    </p>
                </div>
            </section>

            <section class="addon-detail">
                <div class="text-content">
                    <div class="caption" i18n="@@addonsVisibilityCaption">Sichtbarkeit</div>
                    <h2 class="display" i18n="@@addonsVisibilityTitle">Ein echter Blickfang</h2>
                    <div class="line"></div>
                    <p class="copy" i18n="@@addonsVisibilityText">
                        Mit seiner markanten Silhouette hebt sich der "Hut mit Ohren" von der Umgebung ab.
                        Machen Sie Ihren Standort zu einem unverwechselbaren Landmark, das man schon von weitem erkennt.
                    </p>
                </div>
            </section>

            <section class="addon-detail">
                <div class="text-content">
                    <div class="caption" i18n="@@addonsQualityCaption">Qualität</div>
                    <h2 class="display" i18n="@@addonsQualityTitle">Massive Konstruktion</h2>
                    <div class="line"></div>
                    <p class="copy" i18n="@@addonsQualityText">
                        Gefertigt aus robustem, pulverbeschichtetem Stahl.
                        Entwickelt für maximale Langlebigkeit und minimalen Wartungsaufwand, egal bei welchem Wetter.
                    </p>
                </div>
            </section>

            <section class="addon-detail">
                <div class="text-content">
                    <div class="caption" i18n="@@addonsFlexibilityCaption">Flexibilität</div>
                    <h2 class="display" i18n="@@addonsFlexibilityTitle">Sicherer Halt</h2>
                    <div class="line"></div>
                    <p class="copy" i18n="@@addonsFlexibilityText">
                        Rückseitige Laschen ermöglichen die einfache Nutzung von Spanngurten.
                        Damit befestigen Sie Ihre <span class="tm">marktbox</span> auch an wechselnden Standorten stets
                        sicher und stabil.
                    </p>
                </div>
            </section>
            <section class="addon-detail">
                <div class="text-content">
                    <h2 class="display" i18n="@@addonsInterestedTitle">Interessiert?</h2>
                    <p class="copy mb-4" i18n="@@addonsInterestedText">
                        Rüsten Sie Ihre <span class="tm">marktbox</span> jetzt auf.
                    </p>
                    <a class="btn btn-primary" [routerLink]="links.shop" i18n="@@addonsShopLink">Zum Shop</a>
                </div>
            </section>
            <div class="content-spacer"></div>
        </div>
    </div>
</div>